import Login from '@svelte/login.component.svelte'
import '@scss/app.scss'

import '~/bootstrap/dist/js/bootstrap.bundle'
import $ from '~/jquery'
import {getUrlParameter} from "@js/common/get-query-string";

window.jQuery = $
window.$ = $

function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    ).replaceAll('-', '');
}

let guid = uuidv4()
if (window.bureau_callback__init) window.bureau_callback__init(guid)

const loginComponent = new Login({
    target: document.getElementById('app'),
    props: {
        end: (document.querySelector('input[name="wl"]')).value === '64',
        sessionId: guid,
        app: (document.querySelector('input[name="app"]'))?.value,
        error: getUrlParameter('err') ? atob(getUrlParameter('err')) : undefined,
        warning: getUrlParameter('warn') ? atob(getUrlParameter('warn')) : undefined,
        maintenanceEnabled: (document.querySelector('input[name="me"]'))?.value,
        maintenanceType: (document.querySelector('input[name="mt"]'))?.value,
        maintenanceMessage: (document.querySelector('input[name="mm"]'))?.value,
        maintenanceLogin: (document.querySelector('input[name="ml"]'))?.value
    }
})

export default loginComponent